import PropTypes from 'prop-types';
import { forwardRef } from 'react';

// material-ui
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';

// header style
const headerSX = {
  p: 2,
  '& .MuiCardHeader-action': { m: '0px auto', alignSelf: 'center' }
};

function MainCard(
  {
    border = false,
    boxShadow = true,
    children,
    content = true,
    contentSX = { p: 2 },
    darkTitle,
    elevation = 0,
    secondary,
    shadow = false,
    sx = {},
    title,
    ...others
  },
  ref
) {
  const theme = useTheme();

  return (
    <Card
      elevation={elevation || 1}
      ref={ref}
      {...others}
      sx={{
        p: 0,
        border: border ? '1px solid' : `1px solid ${theme.palette.divider}`,
        borderRadius: '8px',
        borderColor: theme.palette.divider,
        background: theme.palette.background.paper,
        boxShadow: boxShadow ? 'none' : 'none',
        transition: theme.transitions.create(['box-shadow'], {
          duration: theme.transitions.duration.shorter
        }),
        '& pre': {
          m: 0,
          p: 0,
          fontFamily: theme.typography.fontFamily,
          fontSize: '0.75rem'
        },
        ...sx
      }}
    >
      {/* card header and action */}
      {!darkTitle && title && (
        <CardHeader
          sx={headerSX}
          titleTypographyProps={{ variant: 'h5' }}
          title={title}
          action={secondary}
        />
      )}
      {darkTitle && title && (
        <CardHeader
          sx={headerSX}
          title={<Typography variant="h4">{title}</Typography>}
          action={secondary}
        />
      )}

      {/* card content */}
      {content && <CardContent sx={contentSX}>{children}</CardContent>}
      {!content && children}
    </Card>
  );
}

export default forwardRef(MainCard);

MainCard.propTypes = {
  border: PropTypes.bool,
  boxShadow: PropTypes.bool,
  children: PropTypes.node,
  subheader: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  content: PropTypes.bool,
  contentSX: PropTypes.object,
  darkTitle: PropTypes.bool,
  divider: PropTypes.bool,
  elevation: PropTypes.number,
  secondary: PropTypes.any,
  shadow: PropTypes.string,
  sx: PropTypes.object,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  modal: PropTypes.bool,
  others: PropTypes.any
};
